import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const LABEL_DEFAULTS = {
  in_stock_badge: "In Stock", out_of_stock_badge: "Enquire", add_to_cart: "Add to Cart",
  enquire_button: "Call for Availability / Enquire", enquire_button_mobile: "Enquire",
  request_quote: "Request a Quote", poa_price: "Enquire for price", incl_gst: "incl. GST",
  save_prefix: "Save", rrp_prefix: "RRP",
  pdp_in_stock: "In Stock · {stock} available", pdp_out_of_stock: "Out of stock — enquire for availability",
  pdp_enquire_button: "Call for Availability / Enquire",
};

let cache = null;
let pending = null;
const subs = new Set();
export const refreshLabels = () => api.get("/site/labels").then((r) => { cache = { ...LABEL_DEFAULTS, ...r.data }; subs.forEach((f) => f(cache)); }).catch(() => {});

// Admin-editable product wording, fetched once and shared by every product card.
export function useLabels() {
  const [l, setL] = useState(cache || LABEL_DEFAULTS);
  useEffect(() => {
    subs.add(setL);
    if (!cache && !pending) pending = refreshLabels();
    return () => { subs.delete(setL); };
  }, []);
  return l;
}
